// 数字の偶数判定
export function isEven(num: number) {
    return num % 2 === 0;
}
  